var _defs, _rect, _polygon, _rect2, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectorsDesignSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Connectors_Design_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.73,
    y: 0.68,
    width: 5,
    height: 8,
    rx: 1,
    transform: "translate(4.66 20.62) rotate(-44.99)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.29 28.42 0.54 31.6 3.63 22.76 21.31 5.09 26.97 10.74 9.29 28.42"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.73,
    y: 0.68,
    width: 5,
    height: 8,
    rx: 1,
    transform: "translate(4.66 20.62) rotate(-44.99)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.29 28.42 0.54 31.6 3.63 22.76 21.31 5.09 26.97 10.74 9.29 28.42"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "8.96 14.61 3.27 8.93 8.93 3.27 10.34 4.69 7.51 7.51 8.22 8.22 11.05 5.39 12.46 6.81 11.05 8.22 11.76 8.93 13.17 7.51 14.59 8.93 16.03 7.54 8.93 0.44 7.51 1.86 1.86 7.51 0.44 8.93 7.54 16.03 8.96 14.61"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.51 16.03 20.27 20.27 20.95 20.95 23.78 18.12 25.19 19.54 23.78 20.95 24.48 21.66 25.9 20.24 27.31 21.66 24.48 24.48 25.19 25.19 28.02 22.36 28.73 23.07 23.07 28.73 17.44 23.1 16.03 24.51 23.07 31.56 24.48 30.14 30.14 24.48 31.56 23.07 24.51 16.03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectorsDesignSvg);
export default __webpack_public_path__ + "static/media/Connectors_Design_svg.e31dd3c74126016dfd3f84650d96ba4e.svg";
export { ForwardRef as ReactComponent };